import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

const MIN_VISIBLE_DURATION_MS = 150

/**
 * Keeps the transition visible until the app page content has rendered.
 */
export const finishAfterPageRendered = store.effects.create(
  (feature: Feature) =>
    feature.actions.pageRendered.observe().pipe(
      rxjs.withLatestFrom(feature.selectors.transition.asObservable),
      rxjs.switchMap(([action, transition]) => {
        if (!transition) {
          return rxjs.EMPTY
        }

        return rxjs.timer(MIN_VISIBLE_DURATION_MS).pipe(
          rxjs.map(() =>
            feature.actions.finishTransition.from(action).create({
              id: transition.id,
            }),
          ),
        )
      }),
    ),
)
